import { LOCAL_STORAGE_OBJECT_FILTER } from "./consts.api";

const saveFilter = filter =>
  localStorage.setItem(LOCAL_STORAGE_OBJECT_FILTER, JSON.stringify(filter));

const getFilter = () => {
  return localStorage.getItem(LOCAL_STORAGE_OBJECT_FILTER)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_OBJECT_FILTER))
    : null;
};

export { saveFilter, getFilter };
